// extracted by mini-css-extract-plugin
export default {"error":"#f44336","colorPrimary":"#de5d2f","colorGrey":"#78909C","colorBlur":"#37BCFF"};